<template>
  <div id="fact-sheet-wrapper">
    <div class="container-fluid" v-show="!getShowWindow">
      <div class="row fact-sheet-button fact-sheet-cursor" v-on:click="updateShowWindow(true)">
        <div class="col">
          <h3 class="d-inline">Quick Facts</h3>
          <p class="float-right d-inline arrows">&gt;&gt;</p>
        </div>
      </div>
      <div v-if="endPath === 'info'" class="row photos-section fact-sheet-collapse home-info" v-on:click="goToCenter('images')">
        <div class="col">
          <h5 class="cursor-pointer fact-sheet-text fact-sheet-title">Photos</h5>
        </div>
      </div>
      <div v-if="endPath === 'info'" class="row fact-sheet-collapse home-info" v-on:click="goToCenter('images')">
        <div class="col text-center">
          <div class="image-wrapper">
            <img class="preview-image" v-for="(image, index) in house.signedPhotos.small.slice(0, 4)" :key="index" v-bind:src="image">
          </div>
        </div>
      </div>
      <div v-if="endPath === 'images'" class="row fact-sheet-collapse home-info" v-on:click="goToCenter('info')">
        <div class="col">
          <h5 class="cursor-pointer fact-sheet-text fact-sheet-title">Property Details</h5>
          <table class="table table-borderless">
            <tbody>
              <tr v-if="house.listPriceStr()">
                <td>
                  <h3 class="fact-sheet-text">${{house.listPriceStr()}}</h3>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-borderless">
            <tbody>
              <tr>
                <td v-if="house.bedroom_count" class="fact-sheet-yellow">{{house.bedroom_count}} Bed</td>
                <td v-if="house.bathroom_count" class="fact-sheet-yellow">{{house.bathroom_count}} Bath</td>
              </tr>
            </tbody>
          </table>
          <table class="table table-borderless">
            <tbody>
              <tr>
                <td class="fact-sheet-text">{{house.street_number}} {{house.street_name}} {{house.street_suffix}}<br>{{house.city}}, {{house.state}} {{house.zip_code}}</td>
              </tr>
            </tbody>
          </table>
          <hr>
        </div>
      </div>
      <div class="row fact-sheet-collapse bottom-radius">
        <div class="col home-info" v-on:click="goBack()">
          <h5 class="fact-sheet-text fact-sheet-title">Back to Search</h5>
          <img class="back-image" src="/static/BackToHouseSearch.svg">
        </div>
      </div>
    </div>
    <div v-show="getShowWindow" id="fact-sheet-expanded">
      <div class="container-fluid">
        <div class="row fact-sheet-button" v-on:click="updateShowWindow(false)">
          <div class="col">
             <h3 class="d-inline">Quick Facts</h3>
          </div>
          <div class="col text-right">
            <p class="fact-sheet-cursor arrows">&lt;&lt;</p>
          </div>
        </div>
      </div>
      <div id="fact-sheet-subexpand"  v-bind:style="{ height: height + 'px' }">
      <div class="container-fluid">
        <div class="row fact-sheet-collapse-trans">
          <div class="col">
            <h2 class="fact-sheet-text">${{ house.listPriceStr() }}</h2>
          </div>
        </div>
        <div class="row fact-sheet-collapse-trans">
          <div class="col col-small">
            <h3 class="fact-sheet-text-yellow d-inline"><i class="fas fa-bed"></i> {{ house.bedroom_count }}</h3>
            <h3 class="fact-sheet-text-yellow d-inline"><i class="fas fa-bath"></i> {{ house.bathroom_count }}</h3>
            <h3 class="fact-sheet-text-yellow d-inline"><i class="fas fa-ruler-combined"></i> {{ house.house_sqft.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} ft<sup>2</sup></h3>
          </div>
        </div>
        <div class="row fact-sheet-collapse-trans">
          <div class="col">
            <p class="fact-sheet-text address-text-fact">{{house.street_number}} {{house.street_name}} {{house.street_suffix}} {{house.city}}, {{house.state}} {{house.zip_code}}</p>
          </div>
        </div>
      </div>
      <hr class="yellow-hr">
      <div class="container-fluid" v-if="pannel === 'default'">
        <div class="row fact-sheet-collapse-trans default-pannel">
          <div class="col-4">
            <p class="fact-sheet-text" v-if="house.style">Property Type:</p>
            <p class="fact-sheet-text" v-if="house.year_built">Year Built:</p>
            <p class="fact-sheet-text" v-if="house.pricePerSqft()">Price per ft<sup>2</sup>:</p>
            <p class="fact-sheet-text" v-if="Number(house.lot_acres)">Lot Size:</p>
          </div>
          <div class="col-8">
            <p class="fact-sheet-text" v-if="house.style">{{ house.style }}</p>
            <p class="fact-sheet-text" v-if="house.year_built">{{ house.year_built }}</p>
            <p class="fact-sheet-text" v-if="house.pricePerSqft()">${{ house.pricePerSqft() }}</p>
            <p class="fact-sheet-text" v-if="Number(house.lot_acres)">{{ Number(house.lot_acres) }} Acres</p>
          </div>
          <div class="col"></div>
        </div>
      </div>
      <div class="fact-sheet-collapse-trans pannel-wrapper" v-if="pannel !== 'default'">
        <div class="container-fluid">
          <propertydetails v-bind:house="house" v-if="pannel === 'propertydetails'"></propertydetails>
          <neighborhood v-bind:loc="house.loc()" v-if="pannel === 'neighborhood'"></neighborhood>
          <schools v-bind:loc="house.loc()" v-if="pannel === 'schools'"></schools>
        </div>
      </div>
      <hr class="yellow-hr">
      <div class="container-fluid">
        <div class="row fact-sheet-collapse-trans">
          <div class="col text-center grid-col grid-col-left" v-on:click="pannel = 'propertydetails'">
            <h4 class="fact-sheet-text table-text">Property Details</h4>
          </div>
          <div class="col text-center grid-col" v-on:click="pannel = 'schools'">
            <h4 class="fact-sheet-text table-text">Nearby Schools</h4>
          </div>
        </div>
      </div>
      <hr class="yellow-hr">
      <div class="container-fluid">
        <div class="row fact-sheet-collapse-trans">
          <div class="col text-center grid-col grid-col-left" v-on:click="pannel = 'neighborhood'">
            <h4 class="fact-sheet-text table-text">Neighborhood</h4>
          </div>
          <div class="col text-center grid-col">
            <h4 class="fact-sheet-text table-text" v-on:click="pannel = 'default'">Quick Facts</h4>
          </div>
        </div>
      </div>
      <!--<hr class="yellow-hr">
      <div class="container-fluid">
        <div class="row fact-sheet-collapse-trans">
          <div class="col text-center grid-col grid-col-left">
            <h4 class="fact-sheet-text table-text">Property History</h4>
          </div>
          <div class="col text-center grid-col">
            <h4 class="fact-sheet-text table-text">Payment Calculator</h4>
          </div>
        </div>
      </div>-->
      <hr class="yellow-hr">
      <div class="container-fluid">
        <div class="row">
          <div class="col grid-col bottom-cell grid-col-left" v-on:click="goBack()">
            <div class="translucent-overlay"><h4 class="fact-sheet-text overlay-text">Back to Search</h4></div>
            <img id="expanded-back-image" src="/static/BackToHouseSearch.svg">
          </div>
          <div class="col grid-col bottom-cell" v-on:click="goToCenter('images')">
            <div class="translucent-overlay"><h4 class="fact-sheet-text overlay-text">Photos</h4></div>
            <img class="preview-image-expanded" v-for="(image, index) in house.signedPhotos.small.slice(0, 4)" :key="index" v-bind:src="image">
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../../../../router/index.js'
import neighborhood from '../dropdowns/Neighborhood.vue'
import propertydetails from '../dropdowns/PropertyDetails.vue'
import schools from '../dropdowns/Schools.vue'
import { mapGetters, mapMutations } from 'vuex'

/* eslint-disable */
var houseSVG = ['<?xml version="1.0" encoding="utf-8"?>',
'<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->',
'<svg version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"',
         'x="0px" y="0px" viewBox="0 0 288 417" style="enable-background:new 0 0 288 417;" xml:space="preserve">',
'<style type="text/css">',
        '.st0{fill:#748096;}',
        '.st1{fill:#363E4A;}',
        '.st2{fill:#FCD990;}',
'</style>',
'<path class="st0" d="M105.5,277v112.4l26.5,23.7c5.7,5.1,18.3,5.1,24.1,0l26.5-23.7V277c-12.5,1.4-25.4,2.2-38.5,2.2',
        'S118,278.4,105.5,277z"/>',
'<circle class="st1" cx="144" cy="144" r="144"/>',
'<path class="st2" d="M140.8,89.9l-77.5,63.8v68.9c0,3.7,3,6.7,6.7,6.7l47.1-0.1c3.7,0,6.7-3,6.7-6.7v-40.2c0-3.7,3-6.7,6.7-6.7h26.9',
        'c3.7,0,6.7,3,6.7,6.7v40.2c0,3.7,3,6.7,6.7,6.7c0,0,0,0,0,0l47.1,0.1c3.7,0,6.7-3,6.7-6.7v-68.9l-77.4-63.7',
        'C145.3,88.4,142.7,88.4,140.8,89.9L140.8,89.9z M263.1,133.3L228,104.3V46.1c0-2.8-2.3-5-5-5h-23.5c-2.8,0-5,2.3-5,5v30.5',
        'l-37.6-30.9c-7.4-6.1-18.2-6.1-25.6,0L24.8,133.3c-2.1,1.8-2.4,5-0.7,7.1c0,0,0,0,0,0l10.7,13c1.8,2.2,4.9,2.5,7.1,0.7c0,0,0,0,0,0',
        'l98.8-81.4c1.9-1.5,4.6-1.5,6.4,0l98.8,81.4c2.1,1.8,5.3,1.5,7.1-0.7c0,0,0,0,0,0l10.7-13C265.6,138.2,265.3,135,263.1,133.3',
        'C263.2,133.3,263.1,133.3,263.1,133.3L263.1,133.3z"/>',
'</svg>'].join('\n')
/* eslint-enable */

export default {
  components: {
    neighborhood,
    propertydetails,
    schools
  },
  async mounted () {
    this.setHeight()
    window.addEventListener('resize', this.setHeight)
  },
  props: {
    house: Object,
    originRoute: String,
    searchString: String
  },
  data () {
    return {
      map: null,
      marker: null,
      expanded: false,
      pannel: 'default',
      height: null
    }
  },
  computed: {
    endPath () {
      return this.$route.params.endPath
    },
    ...mapGetters('homeSearch', [
      'getShowWindow'
    ])
  },
  methods: {
    ...mapMutations('homeSearch', [
      'updateShowWindow'
    ]),
    setHeight () {
      var windowHeight = window.innerHeight
      var factSheetWrapper = document.getElementById('fact-sheet-subexpand')
      if (!factSheetWrapper) return
      var rect = factSheetWrapper.getBoundingClientRect()
      this.height = windowHeight - rect.top
    },
    goBack () {
      router.push(this.originRoute)
    },
    goToCenter (center) {
      router.push('/propertysearch/' + this.$route.params.id + '/' + this.$route.params.searchString + '/' + center)
    }
  }
}
</script>

<style scoped>
.address-text-fact {
  padding-top: 1rem;
}

.arrows {
  font-size: 1rem;
}

.back-image {
  margin-bottom: 1rem;
  height: 150px;
  width: 100%;
  object-fit: cover;
}

.col-small {
  padding-right: 0;
}

.default-pannel {
  padding-top: 1rem;
}

.grid-col {
  cursor: pointer;
}

.pannel-wrapper {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.pannel-wrapper >>> .detail-subsection {
  color: white !important;
}

.pannel-wrapper >>> p {
  color: white !important;
}

.pannel-wrapper >>> h6 {
  color: white !important;
}

.pannel-wrapper >>> label {
  color: white !important;
}

.pannel-wrapper >>> li {
  color: white !important;
}

.table-text {
  padding: 1rem;
}

.grid-col-left {
  border-right: 1px solid rgb(254, 237, 170);
}

.grid-col {
  padding-right: 0;
  padding-left: 0;
}

.yellow-hr {
  margin-top: 0 !important;
  border-color: rgb(254, 237, 170) !important;
}

#fact-sheet-expanded {
  position: fixed;
  width: 500px;
  z-index: 500;
}

#fact-sheet-subexpand {
  overflow: auto;
}

#fact-sheet-wrapper {
  position: relative;
}

.fact-sheet-cursor {
  cursor: pointer;
}

hr {
  border-color: white !important;
  margin-bottom: 0;
}

.address-text {
  font-size: 12px !important;
}

.home-info {
  cursor: pointer;
}

.preview-image {
  cursor: pointer;
  object-fit: cover;
  height: 75px;
  width: 48%;
}

.preview-image-expanded {
  cursor: pointer;
  object-fit: cover;
  height: 75px;
  width: 50%;
}

.bottom-cell {
  position: relative;
  height: 150px;
}

.fact-sheet-text {
  color: white !important;
}

.fact-sheet-text-yellow {
  color: rgb(254, 237, 170) !important;
  padding-right: 2rem;
}

.fact-sheet-title {
  margin-top: .5rem;
}

.fact-sheet-collapse {
  background-color: rgb(54, 62, 74);
}

.fact-sheet-collapse-trans {
  background-color: rgb(54, 62, 74, .8);
}

.bottom-radius {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.fact-sheet-button {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: rgb(254, 237, 170);
}

.fact-sheet-yellow {
  color: rgb(254, 237, 170) !important;
}

table {
  margin-bottom: 0;
}

td {
  padding: 0;
}

#expanded-back-image {
  width: 100%;
  height: 100%;
}

.translucent-overlay {
  background-color: rgb(54, 62, 74, .8);
  color: white;
  height: 150px;
  width: 100%;
  position: absolute;
}

.overlay-text {
  text-align: center;
  line-height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/leftSide/FactSheet.vue